/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_TitleInputs */

const en_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset all filter controls`)
};

const fr_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinitialiser tous les controles de filtre`)
};

const de_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Filtersteuerungen zurücksetzen`)
};

const it_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta tutti i controlli del filtro`)
};

const ru_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить все настройки фильтра`)
};

const es_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer todos los controles de filtro`)
};

const zh_cn2_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置所有过滤器控制`)
};

const ja_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのフィルターコントロールをリセット`)
};

const hi_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी फ़िल्टर नियंत्रण रीसेट करें`)
};

const pt_pt2_video_filters_reset_title = /** @type {(inputs: Video_Filters_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar todos os controles do filtro`)
};

/**
* | output |
* | --- |
* | "Reset all filter controls" |
*
* @param {Video_Filters_Reset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_title = /** @type {((inputs?: Video_Filters_Reset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_reset_title(inputs)
	if (locale === "de") return de_video_filters_reset_title(inputs)
	if (locale === "it") return it_video_filters_reset_title(inputs)
	if (locale === "ru") return ru_video_filters_reset_title(inputs)
	if (locale === "es") return es_video_filters_reset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_reset_title(inputs)
	if (locale === "ja") return ja_video_filters_reset_title(inputs)
	if (locale === "hi") return hi_video_filters_reset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_reset_title(inputs)
	return en_video_filters_reset_title(inputs)
});